import styled from 'styled-components';

export const StepTitleWrapper = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 24px;
    margin-right: 0 !important;
`;

export const StepTitleButtons = styled.div`
    display: flex;
    gap: 24px;
`;
